<template>
  <div class="home">
    <header style="height: 969px;">
      <a href="http://liveperformance.com.au" target="_blank" title="Live Performance Australia" class="lpalogo">Live
        Performance Australia</a>
      <div class="row clearfix">
        <h1>
          <router-link to="/ticket-survey-2019">LPA Ticket Attendance<span></span> and Revenue Report 2019</router-link>
        </h1>
        <nav>
          <div class="sticky-wrapper">
            <ul>
              <li class="navtoggle"><a href="#" id="navtoggle">Show Sections</a></li>
              <li>
                <a href="#intro">Overview</a>
                <ul>
                  <li><a href="#intro">Introduction</a></li>
                  <li><a href="#overview">Overview</a></li>
                  <li><a href="#overall-trends">Overall Trends</a></li>
                  <!-- <li><a href="#overview-supplementary">Supplementary Data</a></li>  -->
                </ul>
              </li>
              <li><router-link to="/ticket-survey-2019/states">States</router-link>
                <ul>
                  <li><a href="#state-overall">Overall Results</a></li>
                  <li><a href="#state-pc-movement">Percentage Movement</a></li>
                  <li><a href="#state-per-capita">Per Capita Results</a></li>
                  <li><a href="#state-results">Individual State Results</a></li>
                </ul>
              </li>
              <li>
                <router-link to="/ticket-survey-2019/categories">Categories</router-link>
                <!--                <a href="http://reports.liveperformance.com.au/ticket-survey-2018/categories">Categories</a>-->
                <ul>
                  <li><a href="#category-overall">Highlights</a></li>
                  <li><a href="#category-trends">Trends</a></li>
                  <li><a href="#category-pc-movement">Percentage Movement</a></li>
                  <!-- <li><a href="#category-rev-share">Revenue Share</a></li>
                  <li><a href="#category-att-share">Attendance Share</a></li> -->
                  <li><a href="#category-results">Individual Category Results</a></li>
                </ul>
              </li>
              <li>
                <router-link to="/ticket-survey-2019/appendix">Appendix</router-link>
                <!--                <a href="http://reports.liveperformance.com.au/ticket-survey-2018/appendix">Appendix</a>-->
              </li>
            </ul>
          </div>
        </nav>
      </div>
      <div class="fullbg">
        <p class="caption">Photo: <em>The Book of Mormon, The Gordon Frost Organisation</em>, Jeff Busby</p>
        <div class="overlay"></div>
      </div>
    </header>

    <section id="main">
      <section id="intro">
        <div class="row clearfix">
          <article id="ceomessage" class="letter clearfix">
            <h1>Introduction</h1>

            <div class="sixcol">

              <p>Live Performance Australia (LPA) takes great pleasure in presenting our Ticket Attendance and Revenue Report for 2018 ("Report"). </p>

              <p>This is our 15th annual Report. It is the principal source of reliable industry statistics for the Australian live performance industry, and represents the most comprehensive information on annual ticket sales for Australian live performance events available. As the leading source for industry results and trends, the Report is drawn upon extensively by the industry, government, media and business.</p>

              <p>The 2018 Report shows that the live performance industry continues to contribute significantly to our economy and cultural ecology. In 2018, over 26 million tickets were issued to live performance events, generating total ticket sales revenue of almost $2.2 billion. That’s more than the combined attendances at Australian Football, Rugby League, Cricket, Soccer, Basketball, Rugby Union, Tennis, Netball and Baseball (Australian Sporting Attendances 2018, Stadiums Australia).</p>

              <p>The live performance industry had a record-breaking year in 2018. Between 2017 and 2018, ticket sales revenue increased by 14.8% and  attendance increased by 14.1%. Conversely, the different genre categories experienced varying shifts in growth and decline. This trend is consistent with previous years and is primarily due to the impact of major tours or events, particularly international tours, in the market in any given year.</p>

            </div>
            <div class="sixcol last">

              <p>We encourage you to explore this digital report in depth. The data and commentary is broken down by both <a href="./ticket-survey-2018/states">state</a>
                and <a href="./ticket-survey-2018/categories">genre</a> categories, providing a detailed analysis of the diverse and dynamic Australian live performance
                market. Genre categories include <a href="./ticket-survey-2018/category/ballet-dance">ballet and dance</a>,
                <a href="./ticket-survey-2018/category/children-family">children’s/family events</a>,
                <a href="./ticket-survey-2018/category/circus-physical-theatre">circus and physical theatre</a>,
                <a href="./ticket-survey-2018/category/classical-music">classical music</a>,
                <a href="./ticket-survey-2018/category/comedy">comedy</a>,
                <a href="./ticket-survey-2018/category/contemporary-music">contemporary music</a>,
                <a href="./ticket-survey-2018/category/festivals-multi-category">festivals (multi-category)</a>,
                <a href="./ticket-survey-2018/category/festivals-single-category">festivals (contemporary music)</a>,
                <a href="./ticket-survey-2018/category/musical-theatre">musical theatre</a>,
                <a href="./ticket-survey-2018/category/opera">opera</a>,
                <a href="./ticket-survey-2018/category/special-events">special events</a>, and
                <a href="./ticket-survey-2018/category/theatre">theatre</a>.</p>

              <p>The development of LPA’s research reports, integral to promoting the value and importance of our industry, is made possible by the provision of data by our data participants, including ticketing companies, self-ticketing venues, event promoters and the Australia Council for the Arts on behalf of the Major Performing Arts companies. The generous cooperation and effort of all data participants is, as always, greatly appreciated.</p>

              <p>We also thank our Report Consultants, <a target="_blank" href="http://www.ey.com/au/en/home">EY</a>, for their professional services in compiling and analysing the ticket data,
                and our Web Designers, <a target="_blank" href="https://paolismith.com.au/">Paoli Smith</a>, for their preparation of the Digital Report. We hope you find the digital format informative and intuitive, allowing ease of comparison with previous year’s data and tracking of trends.</p>

              <p>
                <img src="/img/2018/ceosignature.jpg" alt="Evelyn Richardson"><br>
                <strong>Evelyn Richardson<br>
                  Chief Executive<br>
                  Live Performance Australia<br><br>
                  November 2019</strong>
              </p>
            </div>
            <div class="twelvecol last">
            </div>
          </article>
          <h1 id="download">Download the Report</h1>

          <p class="execsumm">
            <a href="pdf/2018/LPA-Ticket-survey-2018-Key-Findings.pdf" class="button execsumm pdf" target="_blank">LPA Key
              Findings Report 2018 (PDF)</a>
            <a href="pdf/2018/LPA-Ticket-survey-2018.pdf" class="button fullreport pdf" target="_blank">LPA Ticket Attendance and Revenue Report 2019 (PDF)</a>
          </p>
        </div>
        <div class="fullbg">
          <p class="caption">Photo: <em>Chinese New Year Concert, Adelaide Symphony Orchestra</em>, Claudio Raschella</p>

          <div class="overlay"></div>
        </div>
      </section>

      <section id="overview">
        <div class="row clearfix">
          <figure class="chart">
            <div class="callouts">
              <aside id="overview-rev-total">
                <h2>$<span class="countup" data-from="0" data-to="2.16" data-decimals="2">0.00</span>b
                </h2>
                <h3>Total Revenue</h3>
              </aside>
              <aside id="overview-rev-growth">
                <h2><span class="countup" data-from="0" data-to="14.8" data-decimals="1">0.0</span>%</h2>
                <h3>Revenue Growth</h3>
              </aside>
              <aside id="overview-att-total">
                <h2><span class="countup" data-from="0" data-to="26.3" data-decimals="1">00.0</span>m
                </h2>
                <h3>Total Attendance</h3>
              </aside>
              <aside id="overview-att-growth">
                <h2><span class="countup" data-from="0" data-to="14.1" data-decimals="1">0.0</span>%</h2>
                <h3>Attendance Growth</h3>
              </aside>
              <aside id="overview-avg-price">
                <h2>$<span class="countup" data-from="0" data-to="99.03" data-decimals="2">00.00</span>
                </h2>
                <h3>Avg Ticket Price</h3>
              </aside>
            </div>
          </figure>

          <article>
            <h1>Ticket Revenue and Attendance Overview</h1>
            <h2>Industry growth</h2>
            <ul>
              <li>In 2018 (calendar year), the Australian live performance industry generated total ticket sales revenue of almost $2.2b, an increase of 14.8% from 2017, when ticket sales totalled $1.88b. This increase in revenue was a result of a 4.7% increase in the total number of paid tickets in 2018, coupled with an increase in the average ticket price by 9.3% from $90.59 to $99.03.</li>
              <li>Approximately 26.3m tickets were issued in 2018, representing an increase of 14.1% from 2017, when 23.0m tickets were issued. Of 26.3m total tickets, the number of paid tickets issued was 21.8m (an increase from 20.8m tickets sold in 2017). The remaining 4.4m tickets issued in 2018 were complimentary, sponsor allocated and zero priced tickets.</li>
              <li>In 2018, the number of tickets issued, revenue generated and the average ticket price ($99.03) for live performance events was the highest recorded since LPA began publishing data in 2004. This was primarily driven by major international tours in the Contemporary Music category during the period, including Pink, Ed Sheeran and Bruno Mars; musicals such as <i>The Book of Mormon, Aladdin</i> and <i>Beautiful: The Carole King Musical</i> and by festivals such as Splendour in the Grass and Adelaide Fringe.</li>
            </ul>
            <h2>Drivers of growth</h2>
            <ul>
              <li>New South Wales (NSW) generated the highest share of national live performance revenue (34.9%) and attendance (31.3%) in 2018, with Victoria being the second largest contributor in revenue (32.3%) and in attendance (30.5%). Combined, NSW and Victoria generated approximately 67.2% of Australia’s live performance revenue and 61.8% of attendance in 2018.</li>
              <li>NSW experienced the greatest growth in revenue (22.4%), closely followed by Queensland (20.2%). The highest growth in attendance was witnessed in Tasmania (67.1%), followed by Queensland (20.1%) and NSW (19.4%).</li>
              <li>Contemporary Music remains the largest category in the industry in 2018, representing a market share of 50.5% in revenue and 38.4% in attendance.</li>
              <li>Revenue growth in Special Events (337.9%), Comedy (72.5%), Contemporary Music (32.2%) and Festivals (Multi-Category) (26.2%) categories has driven growth in the live performance industry in 2018 as compared to 2017. This growth was partially offset by revenue declines in Circus and Physical Theatre (79.9%) and Musical Theatre (4.0%).</li>
            </ul>
          </article>
        </div>

        <div class="fullbg">
          <p class="caption">Photo: <em>Giselle, The Australian Ballet</em>, Jeff Busby</p>
          <!--<div class="overlay"></div>-->
        </div>
      </section>

      <section id="overall-trends">
        <article>
          <div class="row clearfix">
            <h1>Overall Trends</h1>
            <div class="sixcol">
              <h2>Key Revenue Insights</h2>
              <ul>
                <li>Total industry revenue more than doubled over the period 2008 to 2018. Revenue has grown at a compound annual growth rate (CAGR) of 7.4% over the same period. </li>
                <li>In 2018, overall industry revenue has grown year-over-year (y-o-y) by 14.8%.</li>
                <li>In 2018, the Special Events category experienced the highest y-o-y increase (337.9%) among all the categories, followed by Comedy (72.5%).</li>
                <li>New South Wales witnessed the highest y-o-y growth in revenue among all the states by 22.4% ($753.7m) in 2018.</li>
              </ul>
              <h2>Key Attendance Insights</h2>
              <ul>
                <li>Total attendance has increased by 66.0% from 15.8m in 2008 to 26.3m in 2018.</li>
                <li>Attendance has grown at a CAGR of 5.2% over the period 2008 to 2018.</li>
                <li>In 2018, the y-o-y attendance growth recorded was 14.1%.</li>
                <li>In 2018, Comedy witnessed the highest y-o-y increase in attendance (98.5%) among all the categories. Among all the states and territories, Tasmania experienced the highest y-o-y growth in attendance (67.1%).</li>
              </ul>
            </div>
            <div class="sixcol last">
              <h2>Key Average Ticket Price Insights</h2>
              <ul>
                <li>The average ticket price increased by 29.2%, from $76.60 in 2008 to $99.03 in 2018.</li>
                <li>The average ticket price has grown at a CAGR of 2.6% over the period 2008 to 2018.</li>
                <li>Average ticket price increased by 9.3% y-o-y in 2018, from $90.59 in 2017 to $99.03 in 2018, which is the highest recorded average ticket price.</li>
                <li>The growth in average ticket price was primarily driven by a surge in the average ticket price in Special Events ($152.70, 202.8% y-o-y growth) and Comedy ($114.20, 83.3% y-o-y growth) categories.</li>
              </ul>
            </div>
          </div>
        </article>
        <figure class="chart">
          <div class="row clearfix">
            <h2>Total Revenue and Attendance</h2>
            <!--            <div id="total-rev-att-graph" class="graphcontainer"></div>-->
            <highcharts class="graphcontainer" :options="chartOptions"></highcharts>
          </div>
        </figure>
        <div class="fullbg">
          <p class="caption">Photo: <em>Baba Yaga, A Windmill Theatre Company and Imaginate production</em>, Rob McDougall</p>
          <div class="overlay"></div>
        </div>
        <figure id="total-rev-att-table" class="data">
          <div class="row clearfix">
            <a href="#" data-table="total-rev-att-table" class="closetable" title="Close Table">Close
              Table</a>
            <h3>Total Revenue, Attendance and Average Ticket Price (2004—2016)</h3>
            <table cellspacing="0" cellpadding="0">
              <thead>
              <tr>
                <th valign="middle" width="10%"></th>
                <th valign="middle" width="15%">Revenue ($)</th>
                <th valign="middle" width="15%">Growth (%)</th>
                <th valign="middle" width="15%">Total Attendance*</th>
                <th valign="middle" width="15%">Growth (%)</th>
                <th valign="middle" width="15%">Average Ticket Price ($)**</th>
                <th valign="middle" width="15%">Growth (%)</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td valign="middle">2004</td>
                <td valign="middle" class="number">689599070.00</td>
                <td valign="middle" class="number">0.00</td>
                <td valign="middle" class="number">13477231.00</td>
                <td valign="middle" class="number">0.00</td>
                <td valign="middle" class="number">55.13</td>
                <td valign="middle" class="number">0.00</td>
              </tr>
              <tr>
                <td valign="middle">2005</td>
                <td valign="middle" class="number">834337206.00</td>
                <td valign="middle" class="number">21.00</td>
                <td valign="middle" class="number">15808790.00</td>
                <td valign="middle" class="number">17.30</td>
                <td valign="middle" class="number">60.62</td>
                <td valign="middle" class="number">10.00</td>
              </tr>
              <tr>
                <td valign="middle">2006</td>
                <td valign="middle" class="number">1158064526.00</td>
                <td valign="middle" class="number">38.80</td>
                <td valign="middle" class="number">19835756.00</td>
                <td valign="middle" class="number">25.50</td>
                <td valign="middle" class="number">64.08</td>
                <td valign="middle" class="number">5.70</td>
              </tr>
              <tr>
                <td valign="middle">2007</td>
                <td valign="middle" class="number">1228658664.00</td>
                <td valign="middle" class="number">6.10</td>
                <td valign="middle" class="number">20887365.00</td>
                <td valign="middle" class="number">5.30</td>
                <td valign="middle" class="number">66.03</td>
                <td valign="middle" class="number">3.10</td>
              </tr>
              <tr>
                <td valign="middle">2008</td>
                <td valign="middle" class="number">1061273304.00</td>
                <td valign="middle" class="number">-13.60</td>
                <td valign="middle" class="number">15823705.00</td>
                <td valign="middle" class="number">-24.20</td>
                <td valign="middle" class="number">76.60</td>
                <td valign="middle" class="number">16.00</td>
              </tr>
              <tr>
                <td valign="middle">2009</td>
                <td valign="middle" class="number">1083329949.00</td>
                <td valign="middle" class="number">2.10</td>
                <td valign="middle" class="number">15196773.00</td>
                <td valign="middle" class="number">-4.00</td>
                <td valign="middle" class="number">80.57</td>
                <td valign="middle" class="number">5.20</td>
              </tr>
              <tr>
                <td valign="middle">2010</td>
                <td valign="middle" class="number">1327805816.00</td>
                <td valign="middle" class="number">22.60</td>
                <td valign="middle" class="number">17241139.00</td>
                <td valign="middle" class="number">13.50</td>
                <td valign="middle" class="number">86.43</td>
                <td valign="middle" class="number">7.30</td>
              </tr>
              <tr>
                <td valign="middle">2011</td>
                <td valign="middle" class="number">1309187150.00</td>
                <td valign="middle" class="number">-1.40</td>
                <td valign="middle" class="number">17345720.00</td>
                <td valign="middle" class="number">0.60</td>
                <td valign="middle" class="number">85.99</td>
                <td valign="middle" class="number">-0.50</td>
              </tr>
              <tr>
                <td valign="middle">2012</td>
                <td valign="middle" class="number">1204883551.00</td>
                <td valign="middle" class="number">-8.00</td>
                <td valign="middle" class="number">16273730.00</td>
                <td valign="middle" class="number">-6.20</td>
                <td valign="middle" class="number">85.46</td>
                <td valign="middle" class="number">-0.60</td>
              </tr>
              <tr>
                <td valign="middle">2013</td>
                <td valign="middle" class="number">1478976893.00</td>
                <td valign="middle" class="number">22.70</td>
                <td valign="middle" class="number">17926626.00</td>
                <td valign="middle" class="number">10.20</td>
                <td valign="middle" class="number">92.16</td>
                <td valign="middle" class="number">7.80</td>
              </tr>
              <tr>
                <td valign="middle">2014</td>
                <td valign="middle" class="number">1507963952.00</td>
                <td valign="middle" class="number">2.00</td>
                <td valign="middle" class="number">18536434.00</td>
                <td valign="middle" class="number">3.40</td>
                <td valign="middle" class="number">91.57</td>
                <td valign="middle" class="number">-0.60</td>
              </tr>
              <tr>
                <td valign="middle">2015</td>
                <td valign="middle" class="number">1413208686.00</td>
                <td valign="middle" class="number">-6.30</td>
                <td valign="middle" class="number">18626457.00</td>
                <td valign="middle" class="number">0.50</td>
                <td valign="middle" class="number">86.34</td>
                <td valign="middle" class="number">-5.70</td>
              </tr>
              <tr>
                <td valign="middle">2016</td>
                <td valign="middle" class="number">1430399693.00</td>
                <td valign="middle" class="number">1.20</td>
                <td valign="middle" class="number">18782588.00</td>
                <td valign="middle" class="number">0.80</td>
                <td valign="middle" class="number">83.72</td>
                <td valign="middle" class="number">-3.00</td>
              </tr>
              <tr>
                <td valign="middle">2017</td>
                <td valign="middle" class="number">1884141882.00</td>
                <td valign="middle" class="number">31.70</td>
                <td valign="middle" class="number">23027550.00</td>
                <td valign="middle" class="number">22.60</td>
                <td valign="middle" class="number">90.59</td>
                <td valign="middle" class="number">8.20</td>
              </tr>
              <tr>
                <td valign="middle">2018</td>
                <td valign="middle" class="number">2162425399.00</td>
                <td valign="middle" class="number">14.80</td>
                <td valign="middle" class="number">26268788.00</td>
                <td valign="middle" class="number">14.10</td>
                <td valign="middle" class="number">99.03</td>
                <td valign="middle" class="number">9.30</td>
              </tr>
              </tbody>
            </table>
            <figcaption>
              <p>*Based on both paid and unpaid tickets</p>
              <p>** Average Ticket Prices are calculated based only on paid tickets</p>
            </figcaption>
          </div>
        </figure>
      </section>
      <nav id="pages">
        <div class="row clearfix">
          <nav id="pages">
            <div class="row clearfix">
              <a href="/ticket-survey-2018/states" class="next sixcol last">States →</a>
            </div>
          </nav>
        </div>
      </nav>

    </section>

    <footer>
      <div class="row clearfix">
        <div class="fivecol">
          <ul class="twelvecol">
            <li class="sixcol">
              <a href="http://liveperformance.com.au" class="lpalogo">
                <img src="http://reports.liveperformance.com.au/img/2018/lpalogo.png" alt="Live Performance Australia">
              </a>
            </li>
            <li class="sixcol last">
              <a href="http://www.ey.com/" class="eylogo">
                <img src="http://reports.liveperformance.com.au/img/2018/eylogo.png" alt="EY">
              </a>
            </li>
          </ul>
          <p>
            © 2018 <a href="http://liveperformance.com.au">Live Performance Australia</a> <br>
            Site by <a href="http://digitalbridge.com.au">Digital Bridge</a><br>
          </p>
        </div>
        <ul class="threecol">
          <li><strong>Ticket Attendance <br>and Revenue Report 2019</strong></li>
          <li>
            <a href="http://reports.liveperformance.com.au/ticket-survey-2018#intro">Overview</a>
          </li>
          <li><a href="http://reports.liveperformance.com.au/ticket-survey-2018/states">States</a>
          </li>
          <li class="current">
            <a href="http://reports.liveperformance.com.au/ticket-survey-2018/categories">Categories</a>
          </li>
          <li><a href="http://reports.liveperformance.com.au/ticket-survey-2018/appendix">Appendix</a></li>
          <li><a href="http://reports.liveperformance.com.au">More LPA Reports</a></li>
        </ul>
      </div>
    </footer>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'OverviewOld',
  data () {
    return {
      chartOptions: {
        chart: {
          type: 'column',
          backgroundColor: 'transparent'
        },
        title: {
          text: 'Total Revenue and Attendance'
        },
        xAxis: {
          categories: [
            '2004',
            '2005',
            '2006',
            '2007',
            '2008',
            '2009',
            '2010',
            '2011',
            '2012',
            '2013',
            '2014',
            '2015',
            '2016',
            '2017',
            '2018',
            '2019',
            '2020'
          ],
          crosshair: true
        },
        yAxis: [
          {
            min: 0,
            title: {
              text: 'Total Attendance'
            }
          },
          {
            lineWidth: 1,
            opposite: true,
            title: {
              text: 'Gross Revenue'
            }
          }
        ],
        series: [
          {
            name: 'Revenue',
            data: [13000000, 15000000, 26000000, 12000000, 16000000, 19000000, 10000000, 5000000, 12000000, 17000000, 22000000, 15000000, 13000000, 16000000, 29000000, 11000000, 14000000]

          },
          {
            name: 'Attendance',
            data: [13000000, 15000000, 26000000, 12000000, 16000000, 19000000, 10000000, 5000000, 12000000, 17000000, 22000000, 15000000, 13000000, 16000000, 29000000, 11000000, 14000000].reverse()
          },
          {
            data: [144.0, 176.0, 135.6, 148.5, 216.4, 194.1, 95.6, 54.4, 29.9, 71.5, 106.4, 129.2],
            yAxis: 1
          }
        ]
      }
    }
  }
}
</script>
